<app-header></app-header>
<section class="hero-wrap hero-wrap-2" style="background-image: url('../../assets/banner.jpg');">
  <div class="overlay"></div>
  <div class="container">
    <div class="row no-gutters slider-text align-items-center justify-content-center">
      <div class="col-md-9 ftco-animate text-center">
        <h1 class="mb-2 bread">ESG and Sustainability Solutions</h1>
      </div>
    </div>
  </div>
</section>



<section class="ftco-section">
  <div class="container">
    <div class="row d-flex">
      <div class="col-md-12 order-md-last wrap-about align-items-stretch">
        <div class="wrap-about-border ftco-animate">
          <div class="img" style="background-image: url(../../assets/esg.jpg);"></div>
          <div class="text">
            <h3>ESG and Sustainability Solutions</h3>
            <p>Companies face a growing need to integrate environmental, social and governance (ESG) principles into enterprise risk management, business strategy, and decision-making. Our ESG and Sustainability Consulting support companies at all stages in their ESG journey, whether that’s taking the first steps, developing an ESG strategy and roadmap, setting a sustainability target or preparing their sustainability report</p>

            <p>Our <span style="color: #ff8416; font-weight: 700">ESG and Sustainability Consulting</span>  Services covers:</p>

            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> ESG assessment and gap-analysis</p>
            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> ESG Sustainability strategy and roadmap</p>
            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> Corporate Compliance & Risk Assessment and benchmarking</p>
            <p><fa-icon [icon]="faCheckCircle" style="font-size:18px; color: #ff8416"></fa-icon> ESG Implementation and Integration</p>
            <p class="ml-4"><fa-icon [icon]="faArrowAltCircleRight" style="font-size:18px; color: #ff8416"></fa-icon> United Nations Sustainable Development Goals (UN SDGs)  </p>
            <p class="ml-4"><fa-icon [icon]="faArrowAltCircleRight" style="font-size:18px; color: #ff8416"></fa-icon> United Nations Global Compact (UN GC)</p>
            <p class="ml-4"><fa-icon [icon]="faArrowAltCircleRight" style="font-size:18px; color: #ff8416"></fa-icon> Global Reporting Initiative (GRI)</p>

            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

